import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import useTranslate from '../../hooks/useTranslate/useTranslate';
import { Policy } from './Policy';

const policyTitles = {
  Cancellation: 'Changes/Cancellation',
  Additional: 'Multiple-Room',
};

const formatPolicyTitle = (camelCase) => {
  const result = camelCase.replace(/([A-Z])/g, ' $1');
  //remove Policy from the end of the string
  const resultWithoutPolicy = result.replace(/ Policy$/, '');
  let policyTitle =
    resultWithoutPolicy.charAt(0).toUpperCase() + resultWithoutPolicy.slice(1);

  if (policyTitles[policyTitle]) {
    policyTitle = policyTitles[policyTitle];
  }

  return policyTitle;
};

const Policies = ({
  policies = {},
  loading,
  showCommission,
  productCode,
  collapsible = true,
}) => {
  const { t } = useTranslate();
  const additionalPolicy = useSelector(
    (state) => state.appSettings.featureFlags.additionalPolicy
  );
  const hotel = useSelector((state) => state.belmond.hotels[productCode]);
  let activePolicies = policies;

  if (loading)
    return (
      <>
        <Skeleton height={20} width={100} containerTestId="skeleton" />
        <Skeleton height={20} width="100%" />

        <Skeleton height={20} width={100} className="mt-4" />
        <Skeleton height={20} width="100%" />
      </>
    );

  if (!showCommission) {
    activePolicies = Object.fromEntries(
      Object.entries(policies).filter(
        ([type, _]) => type !== 'commissionPolicy'
      )
    );
  }

  if (additionalPolicy?.enabled) {
    activePolicies = {
      ...activePolicies,
      additionalPolicy: [{ description: additionalPolicy.metadata.policyText }],
    };
  }

  if (hotel?.address?.countryCode === 'PE') {
    activePolicies = {
      ...activePolicies,
      cashPaymentRestriction: [
        {
          description: t(
            'According to Peruvian law (Law No. 28194), cash is not accepted for payments from PEN. 2,000.00 or USD 500.00. These currencies must be settled by credit card or other methods approved by the hotel and Peruvian law. Payments cannot be split between currencies. This is in accordance with the new provisions in force as of April 17, 2021 (DS No. 005-2021-MINCETUR).'
          ),
        },
      ],
      minorsEntryRequirements: [
        {
          description: t(
            'For the entry of minors accompanied by one or both parents, it is mandatory to carry the passport or identity card of the minor. It is also a requirement to present at the hotel, the birth certificate and the passport or identity card of the accompanying parent, as appropriate.'
          ),
        },
      ],
    };
  }

  return (
    <>
      {Object.keys(policies).length === 0 ? (
        <div>{t('No policies could be loaded.')}</div>
      ) : (
        Object.entries(activePolicies)
          .filter(([_, items]) => items.length)
          .map(([type, items]) => (
            <Policy
              title={t(formatPolicyTitle(type))}
              description={items}
              type={type}
              key={type}
              collapsible={collapsible}
            />
          ))
      )}
    </>
  );
};

Policies.propTypes = {
  policies: PropTypes.object,
  loading: PropTypes.bool,
  showCommission: PropTypes.bool,
  productCode: PropTypes.string.isRequired,
  collapsible: PropTypes.bool,
};

export default Policies;
